module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_courses_easter_de-13d94b4c2b7e8dbeca99e223c1adcf87.png";